import TopicTwo from "../../resource-contents/analytical-tools-contents/TopicTwo";

const AnalyticalToolsContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Choose The Pips Analytical Tools</h1>
            <p>
              Built for precision and confidence, The Pips Analytical Tools help
              you analyze, adapt, and act smarter in every market condition.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Live Market Feed Integration</h4>
                </div>
                <p>
                  Access real-time global market data with continuously updated
                  prices and insights.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Multi-Device Synchronization</h4>
                </div>
                <p>
                  Stay connected across all devices. Your charts, trades, and
                  strategies sync instantly on desktop, web, and mobile.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Trend Visualization</h4>
                </div>
                <p>
                  Understand market trends instantly with advanced visual tools.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalyticalToolsContentFive;
